import {computed, Injectable, signal} from '@angular/core';
import {FilterService} from '@progress/kendo-angular-grid';
import {FilterDescriptor} from '@progress/kendo-data-query';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface';
import {FilterDescriptors} from '@q9elements/ui-kit/components';
import {chain, cloneDeep, groupBy, isEqual} from 'lodash';

import {GridView} from '../models/interfaces';

@Injectable()
export class GridViewsFilterService extends FilterService {
  filters = signal<FilterDescriptors>([], {equal: isEqual});
  isFiltersValid = computed(() => {
    return this.filters().every(filter => this.isFilterValid(filter));
  });

  override filter(filter: CompositeFilterDescriptor) {
    const filters = <FilterDescriptors>filter.filters;

    this.filters.update(state => this.mergeFilters(state, filters));
  }

  initFilters(view: GridView) {
    if (view.filters) {
      this.filters.set([...view.filters]);
    }
  }

  addOrReplaceFilter(field: string, index?: number) {
    const filter = {
      field,
      operator: '',
      value: ''
    };

    this.filters.update(state => {
      const filters = cloneDeep(state);

      if (typeof index === 'number') {
        filters[index] = filter;
      } else {
        filters.push(filter);
      }

      return filters;
    });
  }

  removeFilter(index: number, isDateRemove: boolean) {
    this.filters.update(state => {
      const filters = cloneDeep(state);

      if (isDateRemove) {
        const isSecondDateIndex = filters.findIndex(
          filter => filter.field === filters[index].field
        );

        filters.splice(isSecondDateIndex, 1);
      }

      filters.splice(index, 1);

      return filters;
    });
  }

  private isFilterValid(filter: FilterDescriptor) {
    const isFilterWithoutValue = filter.operator === 'isnotempty' || filter.operator === 'isempty';

    return filter.field && filter.operator && (filter.value || isFilterWithoutValue);
  }

  private mergeFilters(state: FilterDescriptors, updates: FilterDescriptors) {
    const groupByField = (filters: FilterDescriptors) => cloneDeep(groupBy(filters, 'field'));

    return chain(groupByField(state)).merge(groupByField(updates)).values().flatten().value();
  }
}
